// ============================================================================
// Spacing Visualization — Global Toggle State
// ============================================================================

import { hookstate, useHookstate } from '@hookstate/core';

const spacingVizStore = hookstate<boolean>(true);

export function useSpacingVizEnabled(): boolean {
  const state = useHookstate(spacingVizStore);
  return state.value;
}

export function toggleSpacingViz(): void {
  spacingVizStore.set((v) => !v);
}

export function setSpacingViz(enabled: boolean): void {
  spacingVizStore.set(enabled);
}
